import { FetchAPI, ParamsSerializer } from './auth-service';

import _get from 'lodash/get';

const defaults = {
    threshold: {
        variable: 'threshold',
        title: 'Threshold',
        hide: true,
        hidden: true,
        headerName: 'Threshold',
        field: 'threshold',
        type: 'number',
        sortable: true,
        valueGetter: d => _get(d, 'row._source.threshold', 0),
        width: 150,
    },
    created: {
        variable: 'created',
        title: 'Created',
        hide: false,
        hidden: false,
        headerName: 'Created',
        field: 'created',
        type: 'date',
        sortable: true,
        valueGetter: d => _get(d, 'row._source.execution_end_time', 0),
        width: 180,
        order: 1,
    },
    detector_id: {
        variable: 'detector_id',
        title: 'Detector Name',
        hide: false,
        hidden: false,
        headerName: 'Detector Name',
        field: 'detector_id',
        type: 'string',
        sortable: false,
        valueGetter: d => _get(d, 'row._source.detector_id', ''),
        width: 150,
        order: 2,
    },
    confidence: {
        variable: 'confidence',
        title: 'Confidence',
        hide: true,
        hidden: true,
        headerName: 'Confidence',
        field: 'confidence',
        type: 'number',
        sortable: true,
        valueGetter: d => _get(d, 'row._source.confidence', 0),
        width: 150,
    },
    anomaly_grade: {
        variable: 'anomaly_grade',
        title: 'Anomaly Grade',
        hide: false,
        hidden: false,
        headerName: 'Anomaly Grade',
        field: 'anomaly_grade',
        type: 'number',
        sortable: true,
        valueGetter: d => _get(d, 'row._source.anomaly_grade', 0),
        width: 150,
        order: 3,
    },
    anomaly_score: {
        variable: 'anomaly_score',
        title: 'Anomaly Score',
        hide: true,
        hidden: true,
        headerName: 'Anomaly Score',
        field: 'anomaly_score',
        type: 'number',
        sortable: true,
        valueGetter: d => _get(d, 'row._source.anomaly_score', 0),
        width: 150,
    },
    severity: {
        variable: 'severity',
        title: 'Severity',
        hide: false,
        hidden: false,
        headerName: 'Severity',
        field: 'severity',
        type: 'number',
        sortable: true,
        valueGetter: d => _get(d, 'row._source.anomaly_score', 0),
        width: 150,
        order: 4,
    },
    expected_values: {
        variable: 'expected_values',
        title: 'Expected Values',
        hide: true,
        hidden: true,
        headerName: 'Expected Values',
        field: 'expected_values',
        type: 'string',
        sortable: false,
        valueGetter: d => _get(d, 'row._source.expected_values', [])
            .map(expected => (`Likelihood: ${expected.likelihood},  Values: ${expected.value_list
                .map(v => `${v.feature_id}: ${v.data}`)
                .join(', ')}`)),
        width: 200,
    },
    threshold: {
        variable: 'threshold',
        title: 'Threshold',
        hide: true,
        hidden: true,
        headerName: 'Threshold',
        field: 'threshold',
        type: 'number',
        sortable: true,
        valueGetter: d => _get(d, 'row._source.threshold', 0),
        width: 150,
    },
    entity1: {
        variable: 'entity_1',
        title: 'Entity 1',
        hide: false,
        hidden: false,
        headerName: 'Entity 1',
        field: 'entity_1',
        type: 'string',
        sortable: false,
        valueGetter: d => _get(d, 'row._source.threshold', 0),
        width: 150,
        order: 5,
    },
    entity2: {
        variable: 'entity_2',
        title: 'Entity 2',
        hide: false,
        hidden: false,
        headerName: 'Entity 2',
        field: 'entity_2',
        type: 'string',
        sortable: false,
        valueGetter: d => _get(d, 'row._source.threshold', 0),
        width: 150,
        order: 6,
    },
    datasource1: {
        variable: 'data_source_1',
        title: 'Data Source 1',
        hide: false,
        hidden: false,
        headerName: 'Data Source 1 (Actual/Expected)',
        field: 'data_source_1',
        type: 'string',
        sortable: false,
        valueGetter: d => _get(d, 'row._source.threshold', 0),
        width: 150,
        order: 7,
    },
    datasource2: {
        variable: 'data_source_2',
        title: 'Data Source 2',
        hide: false,
        hidden: false,
        headerName: 'Data Source 2 (Actual/Expected)',
        field: 'data_source_2',
        type: 'string',
        sortable: false,
        valueGetter: d => _get(d, 'row._source.threshold', 0),
        width: 150,
        order: 8,
    },
    datasource3: {
        variable: 'data_source_3',
        title: 'Data Source 3',
        hide: false,
        hidden: false,
        headerName: 'Data Source 3 (Actual/Expected)',
        field: 'data_source_3',
        type: 'string',
        sortable: false,
        valueGetter: d => _get(d, 'row._source.threshold', 0),
        width: 150,
        order: 9,
    },
    index: {
        variable: 'index',
        title: 'Index',
        hide: true,
        hidden: true,
        headerName: 'Index',
        field: '_index',
        type: 'string',
        sortable: true,
        valueGetter: d => _get(d, 'row._index', ''),
        width: 200,
    },
    id: {
        variable: 'id',
        title: 'ID',
        hide: true,
        hidden: true,
        headerName: 'ID',
        field: '_id',
        type: 'string',
        sortable: true,
        valueGetter: d => _get(d, 'row._id', ''),
        width: 150,
    },
    version: {
        variable: 'version',
        title: 'Version',
        hide: true,
        hidden: true,
        headerName: 'Version',
        field: '_version',
        type: 'number',
        sortable: true,
        valueGetter: d => _get(d, 'row._version', 0),
        width: 100,
    },
    seq_no: {
        variable: 'seq_no',
        title: 'Sequence Number',
        hide: true,
        hidden: true,
        headerName: 'Sequence Number',
        field: '_seq_no',
        type: 'number',
        valueGetter: d => _get(d, 'row._seq_no', 0),
        sortable: true,
        width: 150,
    },
    primary_term: {
        variable: 'primary_term',
        title: 'Primary Term',
        hide: true,
        hidden: true,
        headerName: 'Primary Term',
        field: '_primary_term',
        type: 'number',
        sortable: true,
        valueGetter: d => _get(d, 'row._primary_term', 0),
        width: 150,
    },
    relevant_attribution: {
        variable: 'relevant_attribution',
        title: 'Relevant Attribution',
        hide: true,
        hidden: true,
        headerName: 'Relevant Attribution',
        field: 'relevant_attribution',
        type: 'string',
        sortable: false,
        valueGetter: d => _get(d, 'row._source.relevant_attribution', [])
            .map(attr => (`${attr.feature_id}: ${attr.data}`))
            .join(', '),
        width: 200,
    },
    model_id: {
        variable: 'model_id',
        title: 'Model ID',
        hide: true,
        hidden: true,
        headerName: 'Model ID',
        field: 'model_id',
        type: 'string',
        sortable: true,
        valueGetter: d => _get(d, 'row._source.model_id', ''),
        width: 200,
    },
    schema_version: {
        variable: 'schema_version',
        title: 'Schema Version',
        hide: true,
        hidden: true,
        headerName: 'Schema Version',
        field: 'schema_version',
        type: 'number',
        sortable: true,
        valueGetter: d => _get(d, 'row._source.schema_version', 0),
        width: 120,
    },
    execution_start_time: {
        variable: 'execution_start_time',
        title: 'Execution Start Time',
        hide: true,
        hidden: true,
        headerName: 'Execution Start Time',
        field: 'execution_start_time',
        type: 'date',
        sortable: true,
        valueGetter: d => _get(d, 'row._source.execution_start_time', 0),
        width: 180,
    },
    execution_end_time: {
        variable: 'execution_end_time',
        title: 'Execution End Time',
        hide: true,
        hidden: true,
        headerName: 'Execution End Time',
        field: 'execution_end_time',
        type: 'date',
        sortable: true,
        valueGetter: d => _get(d, 'row._source.execution_end_time', 0),
        width: 180,
    },
    data_start_time: {
        variable: 'data_start_time',
        title: 'Data Start Time',
        hide: true,
        hidden: true,
        headerName: 'Data Start Time',
        field: 'data_start_time',
        type: 'date',
        sortable: true,
        valueGetter: d => _get(d, 'row._source.data_start_time', 0),
        width: 180,
    },
    data_end_time: {
        variable: 'data_end_time',
        title: 'Data End Time',
        hide: true,
        hidden: true,
        headerName: 'Data End Time',
        field: 'data_end_time',
        type: 'date',
        sortable: true,
        valueGetter: d => _get(d, 'row._source.data_end_time', 0),
        width: 180,
    },
    feature_data: {
        variable: 'feature_data',
        title: 'Feature Data',
        hide: true,
        hidden: true,
        headerName: 'Feature Data',
        field: 'feature_data',
        type: 'string',
        sortable: false,
        valueGetter: d => _get(d, 'row._source.feature_data', [])
            .map(feature => (`${feature.feature_id} (${feature.feature_name}): ${feature.data}`)),
        width: 200,
    },
};

const MC2CHECK = process.env.BRICATA_APPLIANCE_TYPE === 'mc2';

class OSAnomalyDataService {
    constructor () {
        if (!OSAnomalyDataService.instance) {
            OSAnomalyDataService.instance = this;
        }
        this.searchPlaceholder = 'Search anomaly entity data';
        this.fields = Object.values(defaults)
            .sort((a, b) => {
                if (a.hide && !b.hide) return 1;
                if (b.hide && !a.hide) return -1;
                if (a.order === undefined && b.order === undefined) {
                    return a.variable.localeCompare(b.variable);
                }
                return (a.order || 0) - (b.order || 0);
            });

        //Get anomalies for a detector
        this.getAnomalies = (id, params, controller) => {
            params = params || {
                limit: 50,
                sort: 'execution_end_time:desc',
            };
            return FetchAPI({
                method: 'GET',
                url: `anomdetect/fetch/anomalies/${id}?${ParamsSerializer(params)}`,
                signal: controller ? controller.signal : undefined,
            });
        };

        //Get anomalies for a detector
        this.getAnomaliesBySeverity = (id, params, severity, controller) => {
            params = { ...params, severity: severity } || {
                limit: 50,
                sort: 'execution_end_time:desc',
                severity: severity,
            };
            return FetchAPI({
                method: 'GET',
                url: `anomdetect/fetch/anomalies/severity/${id}?${ParamsSerializer(params)}`,
                signal: controller ? controller.signal : undefined,
            });
        };

        //Get all anomalies data
        this.getAllAnomalies = (filtered, params, controller) => {
            params = params || {
                limit: 50,
                sort: 'execution_end_time:desc',
            };
            return FetchAPI({
                method: 'GET',
                url: `anomdetect/fetch/anomalies/union${filtered ? 'filtered' : ''}?${ParamsSerializer(params)}`,
                signal: controller ? controller.signal : undefined,
            });
        };

        //Get all anomalies data
        this.getAllAnomaliesBySeverity = (params, severity, controller) => {
            params = { ...params, severity: severity } || {
                limit: 50,
                sort: 'execution_end_time:desc',
                severity: severity,
            };
            return FetchAPI({
                method: 'GET',
                url: `anomdetect/fetch/anomalies/unionseverity?${ParamsSerializer(params)}`,
                signal: controller ? controller.signal : undefined,
            });
        };

        this.searchAnomalies = (search, params, controller) => {
            params = {
                ...params,
                term: search,
            };
            return FetchAPI({
                method: 'GET',
                url: `anomdetect/fetch/anomalies/search?${ParamsSerializer(params)}`,
                signal: controller ? controller.signal : undefined,
            });
        };

        //Get one anomaly
        this.getAnomaly = (id) => {
            return FetchAPI({
                method: 'GET',
                url: `anomdetect/fetch/anomalies/select?ids=${id}`,
            });
        };

        //Get result index doc count
        this.getResultIndexDocCount = () => {
            return FetchAPI({
                method: 'GET',
                url: `anomdetect/fetch/resindex/doccount/${id}`
            });
        };
        
        //Get Anomalies doc count
        this.getAnomalyDocCount = (id) => {
            return FetchAPI({
                method: 'GET',
                url: `anomdetect/fetch/anomalies/doccount/${id}`
            });
        };
        
        //Get Aggregate doc count
        this.getAggregateDocCount = () => {
            return FetchAPI({
                method: 'GET',
                url: 'anomdetect/fetch/doccountaggr'
            });
        };
        
        //Get heatmap data
        this.getHeatmap = (interval, start, end) => {
            return FetchAPI({
                method: 'GET',
                url: `anomdetect/fetch/anomalies/heatmap?aggrinterval=${interval}&from=${start}&to=${end}`
            });
        };

        //Get heatmap data
        this.getHeatmapByRule = (ruleID, interval, start, end) => {
            return FetchAPI({
                method: 'GET',
                url: `anomdetect/fetch/anomalies/heatmap/${ruleID}?aggrinterval=${interval}&from=${start}&to=${end}`
            });
        };

        this.getSavedSearches = () => {
            try {
                let searches = localStorage.getItem('savedSearches_osAnlomalies') || '[]';
                if (searches.length < 1) searches = '[]';
                return JSON.parse(searches);
            } catch (err) {
                console.log('getSavedSearches error', err);
                return [];
            }
        };

        this.saveSearch = (str) => {
            if (!str || !str.length) return;
            const searches = this.getSavedSearches();
            const i = searches.findIndex(s => s === str);
            if (i >= 0) searches.splice(i, 1);
            searches.unshift(str);
            searches.splice(5);
            localStorage.setItem('savedSearches_osAnlomalies', JSON.stringify(searches));
        };

        return OSAnomalyDataService.instance;
    }
}
const OSAnomalyService = new OSAnomalyDataService();

export {
    OSAnomalyService as default,
};
